import { TablePagination } from "@mui/material";
import { useEffect, useState } from "react";

function usePagination(
  initialPage = 0,
  initialRowsPerPage = 10,
  data,
  paginationEndpointTotalCount = null,
  handleInitializeData,
  handleFetchMoreAlerts
) {
  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
  const [visitedPages, setVisitedPages] = useState([initialPage]);

  useEffect(() => {
    setPage(initialPage)
    setVisitedPages([initialPage])
  }, [paginationEndpointTotalCount, initialRowsPerPage])

  const totalPages = paginationEndpointTotalCount
    ? Math.ceil(paginationEndpointTotalCount / rowsPerPage)
    : Math.ceil(data.length / rowsPerPage);

  function handleChangePage(event, newPage) {
    if (newPage > page) {
      if (handleFetchMoreAlerts && !visitedPages.includes(newPage)) {
        setVisitedPages([...visitedPages, newPage])
        handleFetchMoreAlerts(newPage, rowsPerPage)
      }
    }

    setPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setVisitedPages([0])
    handleInitializeData(0, parseInt(event.target.value, 10))
  }

  const visibleRows = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return {
    visibleRows,
    page,
    rowsPerPage,
    paginationComponent: (
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={paginationEndpointTotalCount ? paginationEndpointTotalCount : data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        nextIconButtonProps={{
          disabled: page >= totalPages - 1, // Disable next button if on the last page
        }}
      />
    ),
  };
}

export default usePagination;